// PatientRoutes.js
import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Roles } from "../constants";
import AppInitializer from "../components/AppInitializer";

function PatientRoutes() {
  return (
    <AppInitializer>
      <AuthGuard role={Roles.PATIENT}>
        <Header />
        <Outlet />
        <Footer />
      </AuthGuard>
    </AppInitializer>
  );
}

export default PatientRoutes;
